import { BackOfficePrivilegeName } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { useUserPermission } from '@hooks/useUserPermission'

/**
 * These privileges are not part of the generated `BackOfficePrivilegeName` enum
 * yet. Once the arriere client is regenerated, replace the casts with the
 * enum members.
 */
export const OPERATIONS_TEAM_ROSTER_READ =
  'OPERATIONS_TEAM_ROSTER_READ' as BackOfficePrivilegeName

export const OPERATIONS_TEAM_ROSTER_WRITE =
  'OPERATIONS_TEAM_ROSTER_WRITE' as BackOfficePrivilegeName

interface TeamRosterPermission {
  /** Can open the market teams screen. */
  canReadTeamRoster: boolean
  /** Can add, edit and delete staff. */
  canWriteTeamRoster: boolean
}

/** @public */
export const useTeamRosterPermission = (): TeamRosterPermission => {
  const canWriteTeamRoster = useUserPermission({ privilegeName: OPERATIONS_TEAM_ROSTER_WRITE })
  const hasReadPrivilege = useUserPermission({ privilegeName: OPERATIONS_TEAM_ROSTER_READ })

  return {
    canReadTeamRoster: hasReadPrivilege || canWriteTeamRoster,
    canWriteTeamRoster,
  }
}
